export const REDEMPTION_CODE_KEY = "redemption-code";
